(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["niji-bilingual-text"] && !Shopify.designMode) return;
  try {
    (() => {
  // Country rules: JP = Japan, US = United States, GB = United Kingdom, CN = China.
  const ENABLE_COUNTRY_DEFAULT = true;
  const JAPANESE_COUNTRIES = new Set(['JP']);
  const DEFAULT_LANGUAGE = 'en';
  const LOOKUP_TIMEOUT_MS = 2500;
  const PREFERENCE_KEY = 'niji-showcase-language-v1';
  const SHOWCASE = 'as-niji-showcase';

  if (!ENABLE_COUNTRY_DEFAULT || window.Shopify?.designMode || !window.customElements) return;

  let manualLanguage = null;
  let countryLanguage = DEFAULT_LANGUAGE;
  let lookupPromise = null;
  let scheduled = false;

  const validLanguage = value => value === 'en' || value === 'ja';
  const showcases = () => Array.from(document.querySelectorAll(SHOWCASE));

  function preferredLanguage(roots) {
    if (validLanguage(manualLanguage)) return manualLanguage;
    const owner = roots.find(root => root.dataset.hasLanguageSwitch === 'true') || roots[0];
    if (owner?.dataset.rememberLanguage === 'true') {
      try {
        const saved = localStorage.getItem(PREFERENCE_KEY);
        if (validLanguage(saved)) return saved;
      } catch (_) { /* The switch also works when browser storage is unavailable. */ }
    }
    return null;
  }

  function applyDefault() {
    const roots = showcases();
    if (!roots.length) return;
    const language = preferredLanguage(roots) || countryLanguage;
    roots.forEach(root => { root.dataset.defaultLanguage = countryLanguage; });
    // Use the section's existing method to keep text, buttons, alt text, and
    // carousel labels synchronized without resetting any selected images.
    const ready = roots.find(root => root.events && typeof root.changeLanguage === 'function');
    ready?.changeLanguage(language);
  }

  function detectCountry() {
    if (lookupPromise) return lookupPromise;
    lookupPromise = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), LOOKUP_TIMEOUT_MS);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = new URL('browsing_context_suggestions.json', new URL(root, window.location.origin));
        endpoint.searchParams.set('country[enabled]', 'true');
        const response = await fetch(endpoint, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) return DEFAULT_LANGUAGE;
        const data = await response.json();
        // Read the detected country, not the current storefront market or
        // browser language. English-speaking browsers in Japan still get Japanese.
        const country = data?.detected_values?.country?.handle;
        return typeof country === 'string' && JAPANESE_COUNTRIES.has(country.toUpperCase())
          ? 'ja' : DEFAULT_LANGUAGE;
      } catch (_) {
        return DEFAULT_LANGUAGE;
      } finally {
        clearTimeout(timeout);
      }
    })();
    return lookupPromise;
  }

  function initialize() {
    const roots = showcases();
    if (!roots.length) return;
    roots.forEach(root => { root.dataset.defaultLanguage = countryLanguage; });
    // Allow the section's custom element to finish its own initialization.
    customElements.whenDefined(SHOWCASE).then(() => {
      requestAnimationFrame(() => {
        applyDefault();
        if (!showcases().length) return;
        if (preferredLanguage(showcases())) return;
        detectCountry().then(language => {
          countryLanguage = language;
          // Re-read preferences: a click while the lookup was pending always wins.
          applyDefault();
        });
      });
    });
  }

  function scheduleInitialize() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      initialize();
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('.niji-language-switch [data-niji-set-language]');
    if (button && validLanguage(button.dataset.nijiSetLanguage)) {
      manualLanguage = button.dataset.nijiSetLanguage;
    }
  }, true);

  // The snippet's bundled script is loaded once. Handle later section inserts
  // without starting a new country request or installing duplicate listeners.
  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        const added = node.matches(SHOWCASE) ? [node] : node.querySelectorAll(SHOWCASE);
        if (added.length) {
          scheduleInitialize();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleInitialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
